import styles from "./Footer.module.css";

export default function Footer({ theme = "dark" }) {
  return (
    <footer className={`${styles.footer} ${styles[theme]}`}>
      <span className={styles.left}>maggiecody.com · 2026</span>
      <div className={styles.links}>
        <a
          href="https://www.linkedin.com/in/marguerite-cody/"
          target="_blank"
          rel="noreferrer"
        >
          linkedin
        </a>
        {/*<a
          href="https://github.com/maggievcody"
          target="_blank"
          rel="noreferrer"
        >
          github
        </a>*/}
      </div>
    </footer>
  );
}
